import React from "react";
import { useSpring, animated } from "@react-spring/web";

const AnimatedPage = ({ children }) => {
  const styles = useSpring({
    from: { opacity: 0, transform: "translateY(50px)" },
    to: { opacity: 1, transform: "translateY(0)" },
    config: { tension: 280, friction: 60 }, // Spring physics for a natural feel
  });

  return <animated.div style={styles}>{children}</animated.div>;
};

export default AnimatedPage;
